import { USER_SESSION_ALLOCATIONS } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';
import {
	CreateUserSessionAllocationProperties,
	UpdateUserSessionAllocationProperties,
	UserSessionAllocationPaginationProperties,
} from '../userAPIProperties';

export const UserSessionAllocation = {
	getAllocations: (data: UserSessionAllocationPaginationProperties) => {
		const { page, pageSize, direction, orderBy, searchString, userId, sessionType, isActive } = data;
		const query = new URLSearchParams();

		if (searchString) query.set('searchString', searchString);
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		if (userId) query.set('userId', userId);
		if (sessionType) query.set('sessionType', sessionType);
		if (typeof isActive === 'boolean') query.set('isActive', isActive.toString());

		return FetchAPI.getJson({
			urlStr: `${USER_SESSION_ALLOCATIONS}/${pageSize}/${page}?${query.toString()}`,
		});
	},

	getAllocation: (id: string) =>
		FetchAPI.getJson({
			urlStr: `${USER_SESSION_ALLOCATIONS}/${id}`,
		}),

	createAllocation: (data: CreateUserSessionAllocationProperties) =>
		FetchAPI.postJson({
			urlStr: USER_SESSION_ALLOCATIONS,
			data,
		}),

	updateAllocation: ({ id, data }: UpdateUserSessionAllocationProperties) =>
		FetchAPI.putJson({
			urlStr: `${USER_SESSION_ALLOCATIONS}/${id}`,
			data,
		}),

	deleteAllocation: (id: string) =>
		FetchAPI.deleteJson({
			urlStr: `${USER_SESSION_ALLOCATIONS}/${id}`,
		}),
	// manually set to be discentery session type - sessionType=9
	getUserActiveAllocations: (userId: string) =>
		FetchAPI.getJson({
			urlStr: `${USER_SESSION_ALLOCATIONS}/user/${userId}/active?sessionType=9`,
		}),

	checkUserHasAllocation: (userId: string) =>
		FetchAPI.getJson({
			urlStr: `${USER_SESSION_ALLOCATIONS}/user/${userId}/has-allocation`,
		}),
};
